/**
 * @flow
 * @relayHash 03e32dccbb86094a36de3ed09e70f91d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type SalesAnalyticsQueryVariables = {||};
export type SalesAnalyticsQueryResponse = {|
  +orders: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +orderNumber: string,
        +status: OrderStatus,
        +totalAmount: ?number,
        +subtotal: ?number,
        +discountAmount: ?number,
        +taxAmount: ?number,
        +orderedAt: ?any,
        +createdAt: any,
        +customer: {|
          +id: string,
          +name: string,
        |},
        +yields: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +orderedQuantity: number,
              +item: {|
                +id: string,
                +name: string,
                +itemNumber: string,
              |},
            |}
          |}>
        |},
      |}
    |}>
  |},
  +purchaseOrders: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +poNumber: string,
        +status: POStatus,
        +totalAmount: number,
        +vendor: ?{|
          +id: string,
          +name: string,
        |},
        +createdAt: any,
      |}
    |}>
  |},
  +invoices: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +invoiceNumber: string,
        +status: InvoiceStatus,
        +totalAmount: number,
        +amountPaid: number,
        +amountDue: number,
        +customer: {|
          +id: string,
          +name: string,
        |},
        +issueDate: ?any,
        +dueDate: ?any,
        +createdAt: any,
      |}
    |}>
  |},
|};
export type SalesAnalyticsQuery = {|
  variables: SalesAnalyticsQueryVariables,
  response: SalesAnalyticsQueryResponse,
|};
*/


/*
query SalesAnalyticsQuery {
  orders(first: 5000) {
    edges {
      node {
        id
        orderNumber
        status
        totalAmount
        subtotal
        discountAmount
        taxAmount
        orderedAt
        createdAt
        customer {
          id
          name
        }
        yields(first: 100) {
          edges {
            node {
              id
              orderedQuantity
              item {
                id
                name
                itemNumber
              }
            }
          }
        }
      }
    }
  }
  purchaseOrders(first: 5000) {
    edges {
      node {
        id
        poNumber
        status
        totalAmount
        vendor {
          id
          name
        }
        createdAt
      }
    }
  }
  invoices(first: 5000) {
    edges {
      node {
        id
        invoiceNumber
        status
        totalAmount
        amountPaid
        amountDue
        customer {
          id
          name
        }
        issueDate
        dueDate
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5000
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAmount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": (v6/*: any*/)
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "orders",
    "storageKey": "orders(first:5000)",
    "args": (v0/*: any*/),
    "concreteType": "OrderConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subtotal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderedAt",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "yields",
                "storageKey": "yields(first:100)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  }
                ],
                "concreteType": "OrderYieldConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderYieldEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderYield",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "orderedQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumber",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "purchaseOrders",
    "storageKey": "purchaseOrders(first:5000)",
    "args": (v0/*: any*/),
    "concreteType": "PurchaseOrderConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "invoices",
    "storageKey": "invoices(first:5000)",
    "args": (v0/*: any*/),
    "concreteType": "InvoiceConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "invoiceNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountPaid",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountDue",
                "args": null,
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "issueDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dueDate",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SalesAnalyticsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v8/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SalesAnalyticsQuery",
    "argumentDefinitions": [],
    "selections": (v8/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SalesAnalyticsQuery",
    "id": null,
    "text": "query SalesAnalyticsQuery {\n  orders(first: 5000) {\n    edges {\n      node {\n        id\n        orderNumber\n        status\n        totalAmount\n        subtotal\n        discountAmount\n        taxAmount\n        orderedAt\n        createdAt\n        customer {\n          id\n          name\n        }\n        yields(first: 100) {\n          edges {\n            node {\n              id\n              orderedQuantity\n              item {\n                id\n                name\n                itemNumber\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  purchaseOrders(first: 5000) {\n    edges {\n      node {\n        id\n        poNumber\n        status\n        totalAmount\n        vendor {\n          id\n          name\n        }\n        createdAt\n      }\n    }\n  }\n  invoices(first: 5000) {\n    edges {\n      node {\n        id\n        invoiceNumber\n        status\n        totalAmount\n        amountPaid\n        amountDue\n        customer {\n          id\n          name\n        }\n        issueDate\n        dueDate\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab4773b5c4e7c9ded2966695f7e31745';
module.exports = node;
